/* eslint-disable perfectionist/sort-enums -- Enum order determines card rendering order via Object.keys() index */
export var MetricsEnergyEnum;
(function (MetricsEnergyEnum) {
    MetricsEnergyEnum["essEnergy"] = "Energy to ESS";
    MetricsEnergyEnum["machineEnergy"] = "Machine energy use";
    MetricsEnergyEnum["residualEnergy"] = "Residual energy balance";
    MetricsEnergyEnum["chargerEnergy"] = "Charger output energy";
    MetricsEnergyEnum["haulerDailyPrediction"] = "Hauler Daily Prediction";
    MetricsEnergyEnum["loadOutDailyProduction"] = "Load Out Daily Production";
})(MetricsEnergyEnum || (MetricsEnergyEnum = {}));
/* eslint-enable perfectionist/sort-enums */
export var MetricsProductivityDurationEnum;
(function (MetricsProductivityDurationEnum) {
    MetricsProductivityDurationEnum["lastDay"] = "Last day";
    MetricsProductivityDurationEnum["lastMonth"] = "Last 30 days";
    MetricsProductivityDurationEnum["lastWeek"] = "Last 7 days";
})(MetricsProductivityDurationEnum || (MetricsProductivityDurationEnum = {}));
export const MetricsData = [
    {
        data: [
            {
                icon: "down",
                id: 1,
                percentage: "6.9%",
                status: "red",
                value: ""
            },
            {
                icon: "up",
                id: 2,
                percentage: "1.25%",
                status: "green",
                value: ""
            },
            {
                icon: "up",
                id: 3,
                percentage: "82.5%",
                status: "red",
                value: ""
            }
        ],
        id: 1,
        kwh: ["1,162.4 kWh", "3,249.9 kWh", "21,600 kWh"],
        metric: "971.3 kWh",
        name: "Energy to ESS"
    },
    {
        data: [
            {
                icon: "up",
                id: 1,
                percentage: "52.8%",
                status: "red",
                value: ""
            },
            {
                icon: "down",
                id: 2,
                percentage: "-5.1%",
                status: "green",
                value: ""
            },
            {
                icon: "up",
                id: 3,
                percentage: "10.1%",
                status: "red",
                value: ""
            }
        ],
        id: 2,
        kwh: ["755 kWh", "5,105.4 kWh", "20,000 kWh"],
        metric: "1,009.3 kWh",
        name: "Machine energy use"
    },
    {
        data: [
            {
                icon: "up",
                id: 1,
                percentage: "45.9%",
                status: "red",
                value: "1.7"
            },
            {
                icon: "down",
                id: 2,
                percentage: "-40.9%",
                status: "green",
                value: "10.9"
            },
            {
                icon: "up",
                id: 3,
                percentage: "82.5%",
                status: "red",
                value: "17.9"
            }
        ],
        id: 3,
        kwh: ["253.7 kWh", "974.8 kWh", "20, 000 kWh"],
        metric: "416.38 kWh",
        name: "Residual Energy balance"
    }
];
